import type { ComponentChildren } from 'preact';
import { createPortal } from 'preact/compat';

// Rendered straight into <body>: a card's backdrop-filter would otherwise confine the fixed overlay
// to the card, and the next card would cover the dialog (bug 2026-10-01).

export function ConfirmDialog(props: {
  title: string;
  children: ComponentChildren;
  confirmLabel: string;
  cancelLabel: string;
  danger?: boolean;
  /** E.g. until the user has typed a confirmation word. */
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return createPortal(
    <div class="overlay" role="presentation" onClick={props.onCancel}>
      <div
        class="dialog card"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="dialog-title"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.key === 'Escape' && props.onCancel()}
      >
        <h2 id="dialog-title">{props.title}</h2>
        <div class="dialog-body">{props.children}</div>
        <div class="dialog-actions">
          <button class="btn" onClick={props.onCancel} autofocus>
            {props.cancelLabel}
          </button>
          <button class={`btn ${props.danger ? 'btn-danger' : 'btn-primary'}`} onClick={props.onConfirm} disabled={props.confirmDisabled}>
            {props.confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
